import React from "react";
import { Link } from "react-router-dom";
import { assets } from "../../assets/assets.js";

const Footer = () => {

    return (
        <div className="footer" id="footer">
            <div className="footer-content">
                <div className="footer-content-left">
                    <div className="logo-container">
                        <img src={assets.logo} alt="E-Gitsawe Logo" />
                        <div className="logo-text">
                            <span className="amharic-title">ኤ-ግጻዌ</span>
                            <span className="amharic-subtitle">እና ስንክሳር</span>
                        </div>
                    </div>
                    <p className="footer-description">
                        የኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተክርስቲያን የዲጂታል መጽሐፍት 
                        ቤት። የሊተርጂካል የቀን መቁጠሪያ፣ የቅዱሳን ዜመናት፣ 
                        የጸሎት ሰዓታት እና መፅሐፍ ቅዱሳዊ ምንጮች።
                    </p>
                    <div className="footer-social-icons">
                        <a href="https://web.facebook.com/hailemariam.eyayu.3/" target="_blank" rel="noopener noreferrer">
                            <img src={assets.facebook_icon} alt="Facebook" />
                        </a>
                        <a href="https://twitter.com/Hailemariam1994" target="_blank" rel="noopener noreferrer">
                            <img src={assets.twitter_icon} alt="Twitter" />
                        </a>
                        <a href="https://wa.me/251938169557" target="_blank" rel="noopener noreferrer">
                            <img src={assets.whatsapp_icon} alt="WhatsApp" />
                        </a>
                        <a href="https://t.me/Hailemariam_SWE" target="_blank" rel="noopener noreferrer">
                            <img src={assets.telegram_icon} alt="Telegram" />
                        </a>
                        <a href="https://www.linkedin.com/in/hailemariam-eyayu/" target="_blank" rel="noopener noreferrer">
                            <img src={assets.linkedin_icon} alt="Linkedin" />
                        </a>
                    </div>
                </div>

                <div className="footer-content-center">
                    <h2 className="section-title">ፈጣን አገናኞች</h2>
                    <ul>
                        <li><Link to="/">መግቢያ</Link></li>
                        <li><a href="#about">ስለ እኛ</a></li>
                        <li><Link to="/bahirehasab">የዕለቱ ጸሎት እና ምንባባት</Link></li>
                        <li><Link to="/privacy-policy">የጥበቃ መመሪያ</Link></li>
                        <li><Link to="/terms-of-service">የአገልግሎት ውሎች</Link></li>
                        <li><Link to="/support">ማጠናከሪያ</Link></li>
                    </ul>
                </div>

                <div className="footer-content-center">
                    <h2 className="section-title">መርጃዎች</h2>
                    <ul>
                        <li><Link to="/bahirehasab">የሊተርጂካል የቀን መቁጠሪያ</Link></li>
                        <li><Link to="/gitsawie">ግጻዌ</Link></li>
                        <li><Link to="/seatat">ሰዓታት</Link></li>
                        <li><Link to="/sinksar">የቅዱሳን ታሪክ</Link></li>
                        <li>
                            <a href="https://t.me/religious_books_lover" target="_blank" rel="noopener noreferrer">
                                📢 ኦርቶዶክሳዊ መጻሕፍት ቴሌግራም
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="footer-content-right">
                    <h2 id="about" className="section-title">አግኙን</h2>
                    <ul className="contact-info">
                        <li>
                            <img src={assets.phone_icon} alt="Phone" />
                            <a href="tel:+251938169557">+251-938169557</a>
                        </li>
                        <li>
                            <img src={assets.email_icon} alt="Email" />
                            <a href="mailto:hailemariameyayu2012@gmail.com">hailemariameyayu2012@gmail.com</a>
                        </li>
                        <li>
                            <img src={assets.location_icon} alt="Location" />
                            <span>አዲስ አበባ, ኢትዮጵያ</span>
                        </li>
                    </ul>
                    <div className="prayer-request">
                        <h3>በጸሎት አስቡኝ</h3>
                        <p>ዲያቆን ኃይለማርያም እና መሐሪ (ወልደ ሥላሴ)</p>
                    </div>
                </div>
            </div>
            
            
            {/* <div className="footer-divider">
                <div className="cross-icon">✝</div>
            </div> */}
            
            <div className="footer-bottom">
              <div className="cross-icon">✝</div>  <p className="footer-copyright">
                     2017 ዓ.ም ኤ-ግጻዌ እና ስንክሳር ሁሉም መብቶች የተጠበቁ ናቸው  © 2017 
                </p>
                <div className="footer-blessing">
                    <span>ተዘከረነ እግዚኦ በውስተ መንግሥትከ።</span>
                </div>
            </div>
        </div>
    );
};

export default Footer;